var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-icon',{attrs:{"color":_setup.makeColor(_vm.active, _vm.isReject)}},[_vm._v(" mdi-circle-medium ")])
}
var staticRenderFns = []

export { render, staticRenderFns }